var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShareKakao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#FFE500"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 18.9756C23.372 18.9756 18 23.2223 18 28.4623C18 31.8729 20.276 34.8623 23.6933 36.5343C23.4427 37.4716 22.784 39.9289 22.6533 40.4542C22.4907 41.1076 22.892 41.0982 23.156 40.9222C23.3627 40.7849 26.444 38.6889 27.7733 37.7849C28.4947 37.8916 29.24 37.9489 30 37.9489C36.628 37.9489 42 33.7023 42 28.4623C42 23.2223 36.628 18.9756 30 18.9756Z",
    fill: "#381E1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShareKakao);
export default __webpack_public_path__ + "static/media/icon_share_kakao.289842668abd1cca60bff39425c62654.svg";
export { ForwardRef as ReactComponent };